import React, { useState } from 'react';
import { InfoOutlined, SearchSharp, TuneSharp } from '@mui/icons-material';
import RightPanel from './RightPanel';
import LeftPanel from './LeftPanel';
import SegmentedPicker from './SegmentedPicker';
import AboutText from './AboutText';
import { ReactComponent as DivirodLogo } from './logos/divirod.svg';

import { ReactComponent as InstagramLogo } from './logos/instagram.svg';
import { ReactComponent as LinkedInLogo } from './logos/linkedin.svg';
import { ReactComponent as YouTubeLogo } from './logos/youtube.svg';
import Legend from './Legend';

function SocialLink({ url, Icon }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      aria-label={url}
    >
      <Icon style={{ height: '24px', margin: '0 4px', fill: 'var(--gray0)' }} />
    </a>
  );
}

export default function MobilePanel() {
  const [selectedPanel, setSelectedPanel] = useState('search');
  return (
    <div className="mobile-panel">
      <div className="mobile-only frosted" style={{ padding: '6px 6px 2px' }}>
        <Legend />
      </div>
      <SegmentedPicker
        options={[
          { key: 'search', label: 'Search', icon: SearchSharp },
          { key: 'controls', label: 'Controls', icon: TuneSharp },
          { key: 'about', label: 'About', icon: InfoOutlined },
        ]}
        selectedOption={selectedPanel}
        setSelectedOption={setSelectedPanel}
      />
      {selectedPanel === 'search' && (
        <LeftPanel />
      )}
      {selectedPanel === 'controls' && (
        <RightPanel />
      )}
      {selectedPanel === 'about' && (
        <div className="frosted about">
          <a
            aria-label="Divirod Website"
            href="https://divirod.com"
            target="_blank"
            rel="noreferrer"
            className="frosted"
          >
            <DivirodLogo className="divirod-logo" />
          </a>
          <h1>Water Level Index Map</h1>
          <AboutText />
          <div
            className="about-text-footer"
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
          >
            <div style={{ textAlign: 'left', height: '24px' }}>
              <SocialLink url="https://www.instagram.com/divirod_inc" Icon={InstagramLogo} />
              <SocialLink url="https://www.linkedin.com/company/divirod" Icon={LinkedInLogo} />
              <SocialLink url="https://www.youtube.com/channel/UC4NdnLAXmUWpR37w3b_g3PA" Icon={YouTubeLogo} />
            </div>
            <div style={{ textAlign: 'right', flex: 1, height: '24px' }}>
              <a
                style={{
                  color: 'var(--gray1)',
                  fontSize: '14px',
                  lineHeight: '24px',
                  fontWeight: 'bold',
                }}
                href="https://www.divirod.com/privacy-policy-1"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
